// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestionCard_container__24C9t","head":"SuggestionCard_head__2VSib","headText":"SuggestionCard_headText__2K8ns","address":"SuggestionCard_address__1se9H"};